import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { MRT_PaginationState } from "mantine-react-table";

export interface VirtualAccountTransactionsResponse {
  data: VirtualAccountTransactions[];
  meta: {
    totalRowCount: number;
  };
}
export interface VirtualAccountTransactions {
  receiverType: string;
  receiverRef: string;
  receiverAccountId: string;
  receiverBankAccountId: string;
  receiverRefId: string;
  receiverStructuredNoteId: string;
  receiverBalanceBefore: string;
  receiverBalanceAfter: string;

  senderType: string;
  senderRef: string;
  senderAccountId: string;
  senderBankAccountId: string;
  senderRefId: string;
  senderStructuredNoteId: string;
  senderBalanceBefore: string;
  senderBalanceAfter: string;

  createdDate: string;
  currency: string;
  amount: string;
  otherCurrency: string;
  amountOtherCurrency: string;
  feesIncurred: string;
  remarks: string;
  status: string;
}

const getVirtualAccountsTransactions = async ({
  token,
  pagination,
  startDate,
  endDate,
}: {
  token: string;
  pagination: MRT_PaginationState;
  startDate: string;
  endDate: string;
}): Promise<VirtualAccountTransactionsResponse> => {
  try {
    const params: Record<string, string> = {
      // Add 1 to pageIndex to convert from 0-based to 1-based index
      page: `${pagination.pageIndex + 1}`,
      pageSize: `${pagination.pageSize}`,
      startDate,
      endDate,
    };

    const response = await axios.get(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/getVATransactions`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params,
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getVirtualAccountsTransactions;
